import { AsyncComponent } from '@frontend/components/common';
import { ObjectListLayoutProvider } from '@frontend/components/list';
import { ReactNode } from 'react';

import Header from '../header/header-component';
import MobileHeader from '../header/mobile-header.component';
import AdminNavbar from '../navigation/admin-navbar.component';

interface AdminAppShellProps {
    children: ReactNode;
}

export function AdminAppShell(props: AdminAppShellProps) {
    return (
        <ObjectListLayoutProvider layout='admin'>
            <div className="bg-background-default flex h-screen w-screen flex-row overflow-hidden font-['Montserrat']">
                <AdminNavbar className='hidden md:inline-flex' />
                <main
                    className='no-scrollbar flex h-screen w-screen flex-col overflow-y-scroll'
                    id='app-content'>
                    <Header className='hidden md:block' />
                    <MobileHeader className='md:hidden' />
                    <div className='flex-grow p-6'>
                        <AsyncComponent>{props.children}</AsyncComponent>
                    </div>
                </main>
            </div>
        </ObjectListLayoutProvider>
    );
}

export default AdminAppShell;
